import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { TranslocoModule } from '@ngneat/transloco';
import { TooltipModule } from '@infomaniak/ngx-tooltip-directive';
import { KsuiteInfoBlockComponent } from './ksuite-info-block.component';

@NgModule({
  declarations: [
    KsuiteInfoBlockComponent,
  ],
  imports: [
    CommonModule,
    MatCardModule,
    TranslocoModule,
    MatButtonModule,
    MatIconModule,
    MatFormFieldModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    TooltipModule,
  ],
  exports: [
    KsuiteInfoBlockComponent,
  ],

})
export class KsuiteBlockInfoModule {
}
